import React, { useCallback, useState } from "react";
import { FormHelperText, Grid, Typography } from "@mui/material";
import Dropzone from "react-dropzone";
import { makeStyles } from "@mui/styles";

const MAX_FILE_SIZE_IN_MB = 5;
const INPUT_HEIGHT = '160px';
const INPUT_WIDTH = '100%';
const ACCEPTED_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/pjpeg', 'image/svg+xml'];
const ACCEPTED_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.svg'];

const CompanyLogoInput: React.FC<CompanyLogoInputProps> = props => {
    const styles = useStyles();
    const [error, setError] = useState<string>();
    const [url, setUrl] = useState<string | undefined>(props.initialPhotoUrl);

    const onDrop = useCallback((files: Array<File>) => {

        for (const file of files) {
            if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
                setError('Niepoprawny plik. Obsługiwany format to ' + ACCEPTED_EXTENSIONS.join(', '));
                return;
            }

            if (file.size / 1024 / 1024 > MAX_FILE_SIZE_IN_MB) {
                setError(`Za duży plik. Max. ${ MAX_FILE_SIZE_IN_MB }MB`);
                return;
            }
        }

        setError(undefined);

        setUrl(URL.createObjectURL(files[0]));

        props.onAttach(files[0]);
    }, [props]);

    return (
        <Grid container item spacing={ 2 }>
            <Grid container item>
                <Dropzone
                    maxFiles={ 1 }
                    onDrop={ onDrop }
                    disabled={ false }
                    accept={ ACCEPTED_FILE_TYPES }
                >
                    { (dropzoneState) => (
                        <Grid
                            container
                            justifyContent='center'
                            flexDirection='column'
                            rowSpacing={ 1 }
                            width={ INPUT_WIDTH }
                            margin={ 0 }
                            padding={ 0 }
                            { ...dropzoneState.getRootProps({ className: styles.dropzone }) }
                        >
                            <input { ...dropzoneState.getInputProps() }/>
                            {
                                url &&
                                <img
                                    className={ styles.img }
                                    src={ url }
                                />
                            }

                            {
                                !url &&
                                <>
                                    <Grid item container justifyContent='center'>
                                        <Typography variant='h4'>LOGO</Typography>
                                        {
                                            error &&
                                            <FormHelperText error>
                                                { error }
                                            </FormHelperText>
                                        }
                                    </Grid>
                                    <Grid item container justifyContent='center' pl={ 1 } pr={ 1 }>
                                        {
                                            !error &&
                                            <Typography variant='caption' textAlign='center'>
                                                Przeciągnij grafikę lub wybierz plik z komputera<br/>
                                                Dopuszczalne formaty: { ACCEPTED_EXTENSIONS.join(', ') }<br/>
                                                Maksymalny rozmiar pliku: { MAX_FILE_SIZE_IN_MB }MB
                                            </Typography>
                                        }
                                    </Grid>
                                </>
                            }

                        </Grid>
                    ) }
                </Dropzone>
            </Grid>
        </Grid>
    )
};
export default CompanyLogoInput;

interface CompanyLogoInputProps {
    readonly onAttach: (file: File) => any;
    readonly initialPhotoUrl?: string;
}

const useStyles = makeStyles(theme => ({
    dropzone: {
        background: theme.palette.primary.light,
        border: '2px dashed ' + theme.palette.primary.main,
        height: INPUT_HEIGHT,
        width: INPUT_WIDTH,
        cursor: 'pointer',
    },
    img: {
        width: INPUT_WIDTH,
        height: INPUT_HEIGHT,
        objectFit: 'contain',
    }
}))